import * as ProgressPrimitive from '@radix-ui/react-progress';

import { cn } from '../../lib/utils';
import type { ProgressProps } from './types';

function Progress({ className, value, ...props }: ProgressProps) {
  value = value || 0;
  return (
    <ProgressPrimitive.Root
      data-slot='progress'
      className={cn(
        'eye:relative eye:h-20 eye:overflow-hidden eye:rounded-full eye:bg-grey-20',
        className,
      )}
      {...props}
    >
      <ProgressPrimitive.Indicator
        data-slot='progress-indicator'
        className={cn(
          value <= 25
            ? 'eye:bg-grey-100'
            : value <= 50
              ? 'eye:bg-blue-50'
              : value <= 85
                ? 'eye:bg-blue-100'
                : 'eye:bg-blue-150',
          'eye:h-full eye:w-full eye:flex-1 eye:rounded-full eye:outline-3 eye:outline-white eye:transition-all',
        )}
        style={{ transform: `translateX(-${100 - value}%)` }}
      />
    </ProgressPrimitive.Root>
  );
}

export { Progress };
